import { removeCalendarProviderAccount as removeCalendarProviderAccountService } from '../services/removeCalendarProviderAccount';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';
import {
    removeCalendarProviderAccount,
    calendarProviderAccountRemoved,
    errorInRemovingCalendarProviderAccount,
} from '../actions/publicActions';
import { getCalendarProviderAccountForType } from '../selectors/calendarProviderAccountsSelectors';

orchestrator(removeCalendarProviderAccount, async actionMessage => {
    const { providerType } = actionMessage;
    const providerAccount = getCalendarProviderAccountForType(providerType);

    try {
        if (providerAccount) {
            await removeCalendarProviderAccountService(providerAccount.id);
            calendarProviderAccountRemoved(providerType, providerAccount.id);
        }
    } catch (error) {
        trace.warn(`Error in removing calendar provider account: ${error.toString()}`);
        errorInRemovingCalendarProviderAccount(providerType);
    }
});
